import { SubscriptionType } from '@/types/shared';

interface CommunityPublishEligibilityArgs {
  isFeatureEnabled: boolean;
  workflowRole: string | null;
  subscriptionType?: SubscriptionType | null;
  isBannedFromCommunityPublishing?: boolean;
  isPaidFigmaUser?: boolean;
  isBlockedByFigmaOrg?: boolean;
}

export type CommunityPublishIneligibilityReason =
  | 'feature_disabled'
  | 'viewer'
  | 'banned'
  | 'enterprise'
  | 'org_member'
  | 'unpaid';

export interface CommunityPublishEligibility {
  canPublish: boolean;
  reason: CommunityPublishIneligibilityReason | null;
}

export const isPaidWeaveSubscription = (subscriptionType?: SubscriptionType | null): boolean =>
  Boolean(subscriptionType && subscriptionType !== SubscriptionType.Free);

export const isEnterpriseWeaveSubscription = (subscriptionType?: SubscriptionType | null): boolean =>
  subscriptionType === SubscriptionType.Enterprise;

export const getCommunityPublishEligibility = ({
  isFeatureEnabled,
  workflowRole,
  subscriptionType,
  isBannedFromCommunityPublishing = false,
  isPaidFigmaUser = false,
  isBlockedByFigmaOrg = false,
}: CommunityPublishEligibilityArgs): CommunityPublishEligibility => {
  if (isFeatureEnabled !== true) return { canPublish: false, reason: 'feature_disabled' };
  if (workflowRole !== 'editor') return { canPublish: false, reason: 'viewer' };
  if (isBannedFromCommunityPublishing) return { canPublish: false, reason: 'banned' };
  if (isEnterpriseWeaveSubscription(subscriptionType)) return { canPublish: false, reason: 'enterprise' };
  if (isBlockedByFigmaOrg) return { canPublish: false, reason: 'org_member' };
  if (isPaidWeaveSubscription(subscriptionType) || isPaidFigmaUser) return { canPublish: true, reason: null };
  return { canPublish: false, reason: 'unpaid' };
};

export const canPublishToCommunity = (args: CommunityPublishEligibilityArgs): boolean => {
  return getCommunityPublishEligibility(args).canPublish;
};
